export default function createPrice(price) {
    return (price ? price / 100 : 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
};